import * as React from 'react';
import { st, classes } from './SocialBarIcon.st.css';
import { Tooltip } from '../Tooltip';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { IconButton, IconButtonSkins } from '../IconButton';
import { useSocialBarContext } from './SocialBarContext';
export const SocialBarIcon = ({ children, tooltip, socialBarTheme, className, hasLiveRegion, ...rest }) => {
    const { mobile } = useTPAComponentsContext();
    const theme = useSocialBarContext();
    const Wrapper = theme ? 'li' : 'div';
    const liveRegion = hasLiveRegion
        ? { role: 'status', 'aria-live': 'polite' }
        : {};
    return (React.createElement(Wrapper, { className: st(classes.root, { theme: theme || socialBarTheme, mobile }, className) },
        React.createElement("div", { ...liveRegion },
            React.createElement(Tooltip, { appendTo: "scrollParent", content: tooltip, placement: "top", disabled: !tooltip || mobile },
                React.createElement(IconButton, { className: classes.iconButton, skin: IconButtonSkins.Full, as: "a", ...rest })))));
};
//# sourceMappingURL=SocialBarIcon.js.map